import React from "react";
import { connect } from "react-redux";
import { Link, ResponsiveImage } from "@quintype/components";
import get from "lodash/get";
import PropTypes from "prop-types";

import humanizeDate from "../../utils/time-format";
import { RenderStoryIcon } from "../../basic/render-story-icon";
import "./styles.m.css";

function HorizontalStoryCardBase({
  story,
  imageAspectRatio,
  cardSize,
  showSection,
  showPublishDate,
  publisherAttributes,
  hideIcon = false,
  pageType
}) {
  const storyObject = story.story ? story.story : story;
  const formattedAspectRatio = JSON.parse(`[${imageAspectRatio}]`);
  const storyHeadingClassName = publisherAttributes.lang === "ur" ? "urdu-story-heading" : "std-story-heading";
  const storyCardClassName = publisherAttributes.lang === "ur" ? "urdu-story-card" : "story-card";
  const sectionDivClassName = publisherAttributes.lang === "ur" ? "urdu-story-content" : "story-content";
  return (
    <Link href={`/${storyObject.slug}`} styleName={`${cardSize === "small" ? "story-card-small" : "story-card-large"}`}>
      <div styleName={storyCardClassName}>
        <div styleName="wrapper" className="wrapper">
          <figure styleName="image-wrapper" className="image-wrapper">
            <ResponsiveImage
              slug={storyObject["hero-image-s3-key"]}
              metadata={storyObject["hero-image-metadata"]}
              alt={storyObject["hero-image-caption"] || storyObject.headline}
              aspectRatio={formattedAspectRatio}
              defaultWidth={480}
              widths={[100, 250, 480, 640]}
              sizes="(max-width: 500px) 98vw, (max-width: 768px)  98vw, 30vw"
              imgParams={{ auto: ["format", "compress"] }}
            />
            {!hideIcon && (
              <RenderStoryIcon storyTemplate={`${storyObject["story-template"]}`} iconSize="icon-medium hideMobile" />
            )}
          </figure>
        </div>
        <div styleName={sectionDivClassName}>
          {showSection &&
            pageType !== "home-page" && (
              <Link href={`/section/${storyObject.sections[0].slug}`}>
                <p styleName="section-name">{get(storyObject, "sections[0].[display-name]")}</p>
              </Link>
            )}
          <h4 styleName={storyHeadingClassName}>{storyObject.headline}</h4>
          {showPublishDate && (
            <div styleName="story-publish">
              <time
                styleName="story-published-date"
                dateTime={`${new Date(storyObject["published-at"]).toISOString().replace("Z", "+00:00")}`}
              >
                <span className="published-time">{humanizeDate(storyObject["published-at"])}</span>
              </time>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}

HorizontalStoryCardBase.propTypes = {
  story: PropTypes.object,
  imageAspectRatio: PropTypes.string,
  showPublishDate: PropTypes.boolean,
  showSection: PropTypes.boolean,
  cardSize: PropTypes.string,
  publisherAttributes: PropTypes.object,
  hideIcon: PropTypes.bool,
  pageType: PropTypes.string
};

function mapStateToProps(state) {
  return {
    pageType: get(state, ["qt", "pageType"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], [])
  };
}

export const HorizontalStoryCard = connect(
  mapStateToProps,
  null
)(HorizontalStoryCardBase);
